import { useContext } from "react";
import { dispatchContext } from "../context";

export function useDispatch() {
	return useContext(dispatchContext);
}
